export default {
  'get-list': {
    method: 'post',
    url: '/client/order/request/list'
  },
  add: {
    method: 'post',
    url: '/client/order/request'
  },
  delete: {
    method: 'delete',
    url: '/client/order/request'
  },
  update: {
    method: 'put',
    url: '/client/order/request/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/client/order/request/status'
  },
  select: {
    method: 'get',
    url: '/client/order/request/find?key=KEY'
  }
}
